<template>
  <section class="hero">
    <div class="columns">
      <div class="column is-8">
        <b-field>
          <b-select
            expanded
            v-model="processId"
            name="process"
            :placeholder="$t('validation.attributes.process')"
          >
            <option v-for="option in processes" :value="option.id" :key="option.id">{{
              option.name
            }}</option>
          </b-select>
        </b-field>
      </div>
    </div>
    <div class="columns is-multiline">
      <div class="column is-12-widescreen is-8-fullhd">
        <div class="box" v-show="processId">
          <div class="columns is-paddingless is-marginless is-multiline">
            <div class="column is-6" v-if="role.admin">
              <b-field>
                <b-select
                  expanded
                  v-model="parentCompanyId"
                  @input="onChangeParentCompanyUser"
                  :placeholder="$t('validation.attributes.company')"
                >
                  <option
                    v-for="option in parentCompanyUsers"
                    :value="option.company.id"
                    :key="option.id"
                    >{{ option.company.name }}</option
                  >
                </b-select>
              </b-field>
            </div>
            <div class="column is-6">
              <b-field>
                <b-select
                  expanded
                  v-model="selectedCompanyUser"
                  :placeholder="$t('validation.attributes.childCompany')"
                >
                  <option v-for="option in companyUsers" :value="option" :key="option.id">{{
                    option.company.name
                  }}</option>
                </b-select>
                <b-button v-if="selectedCompanyUser" @click="addCompanyUser">
                  {{ $t('button.add') }}
                </b-button>
                <b-button v-else disabled>{{ $t('button.add') }}</b-button>
              </b-field>
            </div>

            <div class="column is-9">
              <div class="example is-vertical">
                <div class="example-component">
                  <section>
                    <div class="field is-grouped-multiline is-grouped">
                      <div class="control">
                        <b-tag
                          v-for="cUser in selectedCompanyUsers"
                          :key="cUser.id"
                          type="is-info"
                          attached
                          aria-close-label="Close tag"
                          closable
                          @close="removeCompanyUser(cUser.id)"
                          >{{ cUser.company.name }}</b-tag
                        >
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            </div>
            <div class="column is-3">
              <b-field grouped style="padding-top:7px">
                <div class="control">
                  <button v-if="applyActive" class="button is-primary" @click="apply">
                    {{ $t('button.apply') }}
                  </button>
                  <button v-else class="button is-info" disabled>{{ $t('button.apply') }}</button>
                </div>
                <slot name="customButtons"></slot>
              </b-field>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="content"
      v-if="processId && selectedCompanyUsers.length > 0 && isApplied"
      style="padding-bottom:10px"
    >
      <p>
        {{
          $t('description.comparePagesDescription', [
            getSelectedProcessName(),
            getSelectedCompanyUserNames()
          ])
        }}
      </p>
    </div>
  </section>
</template>
<script>
import { mapGetters } from 'vuex'
import ApiService from '../../_api/api.service'

export default {
  props: {
    options: {
      type: Object,
      default: () => ({
        visibility: {}
      })
    }
  },
  data () {
    return {
      userIds: [],
      processId: null,
      processes: [],
      parentCompanyUsers: [],
      companyUsers: [],
      selectedCompanyUser: null,
      selectedCompanyUsers: [],
      parentCompanyId: null,
      isApplied: false
    }
  },
  computed: {
    ...mapGetters(['currentUser', 'role']),
    applyActive () {
      return this.processId && this.selectedCompanyUsers.length > 0
    }
  },

  mounted () {
    this.getProcesses()
    this.getUsers()
  },
  methods: {
    apply () {
      this.$emit('apply', {
        processId: this.processId,
        users: this.selectedCompanyUsers
      })
      this.isApplied = true
    },
    getProcesses () {
      ApiService.query('/process').then(data => {
        data = data.filter(x => x.processGroupId == null)
        if (this.role.company && !this.role.companyDefaultProcess) {
          this.processes = data.filter(x => x.parentCompanyId === this.currentUser.companyId)
        } else {
          this.processes = data
        }
      })
    },
    getSelectedProcessName () {
      if (this.processId) {
        var selectedProcess = this.processes.filter(x => x.id === this.processId)[0]
        return selectedProcess.name
      }
      return null
    },
    getSelectedCompanyUserNames () {
      const selectedCompanyUserNames = this.selectedCompanyUsers.map(x => x.company.name).join(',')
      return selectedCompanyUserNames
    },
    getUsers () {
      ApiService.get('/select/companyusers').then(data => {
        this.users = data
        this.parentCompanyUsers = data.filter(d => d.parentCompanyId == null && d.company != null)
        if (this.role.company && this.currentUser.companyId) {
          this.parentCompanyId = this.currentUser.companyId
          this.onChangeParentCompanyUser(this.parentCompanyId)
        }
      })
    },
    onChangeParentCompanyUser (parentCompanyId) {
      this.selectedCompanyUser = null
      this.companyUsers = this.users.filter(u => u.parentCompanyId === parentCompanyId)
      this.selectedCompanyUsers = []
    },
    addCompanyUser () {
      if (this.selectedCompanyUser) {
        const sameCompanyUsers = this.selectedCompanyUsers.filter(
          x => x.id === this.selectedCompanyUser.id
        )
        if (sameCompanyUsers.length < 1) {
          this.selectedCompanyUsers.push(this.selectedCompanyUser)
        }
      }
    },
    removeCompanyUser (id) {
      this.selectedCompanyUsers = this.selectedCompanyUsers.filter(c => c.id !== id)
    }
  }
}
</script>
<style>
.example {
  position: relative;
  display: flex;
  flex-direction: column;
  border: 1px solid #ffdd57;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
  color: rgba(0, 0, 0, 0.7);
}
.example-label {
  background: #ffdd57;
  border-radius: 4px 4px 0 0;
  bottom: 100%;
  content: 'Example';
  display: inline-block;
  font-size: 8px;
  font-weight: 700;
  left: -1px;
  padding: 4px 8px;
  position: absolute;
  text-transform: uppercase;
  vertical-align: top;
}
.example-component {
  padding: 1.5rem;
}
</style>
